export function isActivityTimelineDrafting({ hasResponseText = false, thoughtSummary = null }) {
  return hasResponseText || thoughtSummary === 'Writing answer...'
}

export function timelineHeaderLabel({ streaming, duration, summary }) {
  if (duration) return duration
  if (streaming) return summary ?? 'Thinking'
  return summary ?? ''
}

export function timelineAnnouncementText({ streaming, duration, summary }) {
  return timelineHeaderLabel({ streaming, duration, summary })
}
